<template>
    <div class="ad-iframe-wrapper">
        <iframe
            ref="adIframe"
            :src="iframeSrc"
            class="full-width-carousel"
            @load="requestAdSize"
        ></iframe>
    </div>
</template>

<script>
export default {
    props: { external_ad_id: { type: String, required: true }},
    data() {
        return { lastHeight: 0, ticking: false }
    },
    computed: {
        iframeSrc() { return `/__ad/slot/${this.external_ad_id}` }
    },
    mounted() {
        window.addEventListener('resize', this.requestAdSize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.requestAdSize)
    },
    methods: {
        // 節流調用
        requestAdSize() {
            if (!this.ticking) {
                this.ticking = true
                requestAnimationFrame(this.adSize)
            }
        },

        // 讀 iframe DOM 計算高度
        adSize() {
            this.ticking = false
            const iframe = this.$refs.adIframe
            if (!iframe || !iframe.contentDocument) return

            const doc = iframe.contentDocument
            const body = doc.body
            if (!body) return

            const height = body.scrollHeight
            if (height !== this.lastHeight) {
                this.lastHeight = height
                iframe.style.height = height + 'px'
            }

            // 監控圖片載入
            Array.from(doc.images).forEach(img => {
                if (!img.complete) img.addEventListener('load', this.requestAdSize)
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@sass/_variables.scss";
@import "~@sass/_mixins.scss";

.full-width-carousel { width: 100%; display: block; border: 0; }

@include narrow {
    .ad-iframe-wrapper {
        padding-top: 3.5rem;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ExternalAdFrame.vue